import React from 'react';
import icFingerPrint from '../../../../../assets/defaultImages/ic-fingerprint.svg';
import icFingerPrintGreen from '../../../../../assets/defaultImages/ic-fingerprint-green.svg';
import { SnackbarProvider } from 'notistack';
import DeleteModal from '../../../../Modals/DeleteModal';
import { permissionObj } from '../../../../../Helpers/permission';
import NotInformation from '../../../../../components/NotInformation';
import {CustomTextField} from "../../../../../components/CustomTextField";
import CaptureFingerApp from '../Functionality/CaptureFingerApp';
import {CameraPlugin, CleanIcon, TrashOutlineIcon} from '../../../../../components/buttons/IconButtons';
import ButtonIcon from '../../../../../components/buttons/ButtonIcon';
import CaptureFingerTable from '../Table/CaptureFingerTable';
import CustomTable from '../../../../../components/table/CustomTable';
import ButtonAction from '../../../../../components/buttons/ButtonAction';
import CustomCard from '../../../../../components/CustomCard';
import {ButtonNextStep} from '../../../../../components/buttons/ButtonNavigation';

const Step6CaptureFinger = ({
    userData, selectedReader, setSelectedReader, fingerprintSrc, fingerprintsList, handleUploadFinger, fingerprintName,
    setFingerprintName, setFingerprintSrc, setUpdated, setCapturing, capturing,
    setEmptyFields, capturedFingerprint, setCapturedFingerprint, updatedFinger, setModified
}) => {

    const { t, DEV, permission, enqueueSnackbar, selectFingerprintsForDelete, setSelectFingerprintsForDelete, deleteFingerprintsShow, setDeleteFingerprintsShow,isAllCheckedFingerprints,
        handleRemoveAllFingerprints, getAccessMethodName, handleClearFingerprint,
        handleCaptureFinger , deleteSelectedFingerprints } = CaptureFingerApp({
        setCapturedFingerprint, setFingerprintSrc, capturing, setCapturing, capturedFingerprint, updatedFinger,
        setFingerprintName, setSelectedReader, fingerprintSrc, fingerprintsList, setUpdated, setModified
        });

    const {tableId, thead, tbody, handleCheckboxChange } = CaptureFingerTable({
        data: fingerprintsList,
        getAccessMethodName: getAccessMethodName,
        setSelectedList: setSelectFingerprintsForDelete
    });

    return (
        <>
            <SnackbarProvider />
            <div className='d-flex flex-row justify-content-between'>
                {userData.id !== '' &&
                    <div className='col-6'>
                        <div className='d-flex justify-content-end w-100 my-2'>
                            <ButtonAction
                                id='btn_ae_delete'
                                name='delete'
                                className='btn-icon-delete'
                                disabled={selectFingerprintsForDelete?.length === 0}
                                Icon={TrashOutlineIcon}
                                onClick={()=>{
                                    setDeleteFingerprintsShow(true)
                                }}
                            />
                        </div>
                        <CustomTable
                            tableId={tableId}
                            thead={thead}
                            tbody={tbody}
                            checkbox={true}
                            checkboxTitle={"de_/_select_all"}
                            isAllChecked={isAllCheckedFingerprints}
                            onChangeCheckbox={handleRemoveAllFingerprints}
                            handleCheckboxChange={handleCheckboxChange}
                            columnActions={false}
                            selectedList={selectFingerprintsForDelete}
                        />
                    </div>
                }

                <div className={userData.id !== '' ? 'col-6' : 'col-12'}>
                    {userData.id === '' || (userData.id !== '' && DEV) || permission?.includes(permissionObj?.WEB_EMPLOYEE_UPDATE) ?
                        <div className='d-flex justify-content-center align-items-center flex-column'>
                            <div className={'d-flex justify-content-between w-510px my-2'}>
                                <ButtonIcon
                                    id='btn_s6cf_start_stop_streaming'
                                    className='btn-icon-option'
                                    Icon={CameraPlugin}
                                    title={'start_enrollment'}
                                    onClick={(e) => {
                                        handleCaptureFinger(e);
                                    }}
                                    iconProps={'btn-icon-svg-12px icon-color-general-00'}
                                />
                                <ButtonIcon
                                    className='btn-clean-secondary-600'
                                    id='btn_s6cf_clean_finger'
                                    Icon={CleanIcon}
                                    title={'clean_fingerprint'}
                                    onClick={(e) => {
                                        handleClearFingerprint(e);
                                    }}
                                    iconProps={'btn-icon-svg-12px icon-color-general-00'}
                                />
                            </div>
                            {selectedReader !== '' && <span className='mt-5'>{t('add_new_fingerprint')}</span>}

                            <CustomCard classes={`w-510px d-flex justify-content-center align-items-center`}>

                                {selectedReader !== '' && (
                                    <img
                                        className='selfie-camera'
                                        src={fingerprintSrc === '' ? icFingerPrint : icFingerPrintGreen}
                                        alt='Fingerprint'
                                    />
                                )}
                                {selectedReader === '' && (
                                    <p className={'text-center'}>{t('instructions_to_capture_finger')}</p>
                                )}

                            </CustomCard>

                            {selectedReader !== '' &&
                                <div className='w-510px my-4'>
                                    <CustomTextField id={"txt_s6cs_name"}
                                                     length={128}
                                                     name={"name"}
                                                     value={fingerprintName}
                                                     trans={"name"}
                                                     type={"text"}
                                                     onChange={(e) => setFingerprintName(e.target.value)}
                                                     emptyFields={true}
                                                     required={true}
                                    />
                                </div>
                            }

                            {selectedReader !== '' && userData.id !== '' && capturedFingerprint !== '' &&
                                <div className='w-510px'>
                                    <ButtonNextStep
                                        id='btn_s6cf_add_fingerprint'
                                        text='add_fingerprint'
                                        click={() => {
                                            if (fingerprintSrc === '') {
                                                enqueueSnackbar(t('fingerprint_not_captured').toUpperCase(), {
                                                    variant: 'error',
                                                });
                                            } else if (fingerprintName !== '') {
                                                handleUploadFinger(userData.id);
                                                setEmptyFields(false);
                                            } else {
                                                setEmptyFields(true);
                                            }
                                        }}
                                    />
                                </div>
                            }

                        </div>
                        :
                        <NotInformation text={t('no_information')} card={true} />
                    }
                </div>

            </div>

            <DeleteModal
                show={deleteFingerprintsShow}
                onHide={() => setDeleteFingerprintsShow(false)}
                onClickFn={() => deleteSelectedFingerprints(selectFingerprintsForDelete)}
                data={selectFingerprintsForDelete}
                description={'are_you_sure_you_want_to_delete'}
                title_modal={t('delete_fingerprints')}
                element_modal={t('fingerprints')}
            />
        </>
    );
};

export default Step6CaptureFinger;
